// So we can switch off all console.logs later
var debug = console.log.bind(console);

function getWhereId(array,id)
{
    for(var i = 0; i < array.length; i++) {
        if(array[i].id == id) return array[i];
    }

    return null;
}

function hasValue(value) {
    return value !== null && value !== undefined
}
